/**
 * @generated SignedSource<<918132631e15fd818d4704c8d35d259c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "informationWindowGeometryId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "informationWindowGeometryId",
    "variableName": "informationWindowGeometryId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconClass",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contrastColor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorOffsetX",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorOffsetY",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opacity",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Image",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "StaticImage",
  "abstractKey": null
},
v17 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "MapElementImageStyle",
    "abstractKey": "__isMapElementImageStyle"
  }
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementIconStyle",
  "kind": "LinkedField",
  "name": "iconStyle",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zIndexOffset",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "style",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomLevelMin",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomLevelMax",
  "storageKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    (v12/*: any*/),
    (v21/*: any*/),
    (v7/*: any*/),
    (v20/*: any*/)
  ],
  "type": "MapElementPathStyle",
  "abstractKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offsetX",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offsetY",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blur",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v29 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "MapElementImageStyle",
    "abstractKey": "__isMapElementImageStyle"
  },
  (v28/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementIconStyle",
  "kind": "LinkedField",
  "name": "iconStyle",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v31 = [
  (v5/*: any*/),
  (v12/*: any*/),
  (v21/*: any*/),
  (v7/*: any*/),
  (v20/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "MapElementZoomLevelStyle",
    "kind": "LinkedField",
    "name": "zoomLevels",
    "plural": true,
    "selections": [
      (v22/*: any*/),
      (v23/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "style",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v24/*: any*/),
          (v28/*: any*/)
        ],
        "storageKey": null
      },
      (v28/*: any*/)
    ],
    "storageKey": null
  },
  (v28/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPathStyle",
  "kind": "LinkedField",
  "name": "borderStyle",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementBackgroundStyle",
  "kind": "LinkedField",
  "name": "backgroundStyle",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementCompoundFeatureStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": [
        (v20/*: any*/),
        (v30/*: any*/),
        (v32/*: any*/),
        (v33/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MapElementShadowStyle",
          "kind": "LinkedField",
          "name": "shadowStyle",
          "plural": false,
          "selections": [
            (v25/*: any*/),
            (v26/*: any*/),
            (v27/*: any*/),
            (v5/*: any*/),
            (v12/*: any*/),
            (v28/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MapElementZoomLevelStyle",
          "kind": "LinkedField",
          "name": "zoomLevels",
          "plural": true,
          "selections": [
            (v22/*: any*/),
            (v23/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "style",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v30/*: any*/)
                  ],
                  "type": "MapElementCompoundFeatureStyle",
                  "abstractKey": null
                },
                (v28/*: any*/)
              ],
              "storageKey": null
            },
            (v28/*: any*/)
          ],
          "storageKey": null
        },
        (v28/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "MapElementCompoundFeature",
  "abstractKey": null
},
v35 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "domId",
  "storageKey": null
},
v37 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isPageSectionBase"
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collapsible",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collapsedHeight",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "columnsRatio",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "columnsOrder",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullHeight",
  "storageKey": null
},
v44 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/)
  ],
  "type": "PageSectionWithHeadingData",
  "abstractKey": "__isPageSectionWithHeadingData"
},
v45 = {
  "kind": "InlineFragment",
  "selections": [
    (v38/*: any*/),
    (v44/*: any*/)
  ],
  "type": "PageSectionSidebarText",
  "abstractKey": null
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    (v4/*: any*/),
    (v13/*: any*/)
  ],
  "type": "PageSectionSidebarLinkBlock",
  "abstractKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v48 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "addRequestTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removeRequestTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UsersGroup",
      "kind": "LinkedField",
      "name": "usersGroup",
      "plural": false,
      "selections": [
        (v28/*: any*/),
        (v47/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alreadyGroupMember",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alreadyRequested",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UsersGroupAuthorizations",
          "kind": "LinkedField",
          "name": "authorizations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sendJoinGroupRequest",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionSidebarUsersGroupRequestLinkBlock",
  "abstractKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hlsUrl",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "format",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaTitle",
  "storageKey": null
},
v54 = [
  (v13/*: any*/),
  (v28/*: any*/)
],
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "transcription",
  "plural": false,
  "selections": (v54/*: any*/),
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "audio",
  "plural": false,
  "selections": (v54/*: any*/),
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "altText",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "x15Url",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "x2Url",
  "storageKey": null
},
v60 = [
  (v13/*: any*/),
  (v58/*: any*/),
  (v59/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/)
],
v61 = [
  (v57/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "large",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ratio",
        "storageKey": null
      },
      (v13/*: any*/),
      (v58/*: any*/),
      (v59/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "medium",
    "plural": false,
    "selections": (v60/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "small",
    "plural": false,
    "selections": (v60/*: any*/),
    "storageKey": null
  },
  (v28/*: any*/)
],
v62 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hlsLibUrl",
      "storageKey": null
    },
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponsiveImage",
      "kind": "LinkedField",
      "name": "cover",
      "plural": false,
      "selections": (v61/*: any*/),
      "storageKey": null
    }
  ],
  "type": "WithBunnyStreamVideo",
  "abstractKey": "__isWithBunnyStreamVideo"
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoplay",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slidesInterval",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "Slide",
  "kind": "LinkedField",
  "name": "slides",
  "plural": true,
  "selections": [
    (v28/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableOverlay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caption",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContentPosition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContentTextColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonBackgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonTextColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayBackgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayOpacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponsiveImage",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": (v61/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "LibraryFile",
  "kind": "LinkedField",
  "name": "files",
  "plural": true,
  "selections": [
    (v28/*: any*/),
    (v47/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileExtension",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "ResourceTarget",
  "kind": "LinkedField",
  "name": "resourceTargets",
  "plural": true,
  "selections": [
    (v28/*: any*/),
    (v47/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v69 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    (v49/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "analyticsData",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v28/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isAnalyticsDatumInterface"
        },
        (v68/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionAnalyticsDataList",
  "abstractKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startsAt",
  "storageKey": null
},
v72 = [
  (v30/*: any*/),
  (v33/*: any*/)
],
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPointStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v30/*: any*/),
    (v33/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementZoomLevelStyle",
      "kind": "LinkedField",
      "name": "zoomLevels",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        (v23/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v72/*: any*/),
              "type": "MapElementPointStyle",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v72/*: any*/),
              "type": "MapElementCompoundFeatureStyle",
              "abstractKey": null
            },
            (v28/*: any*/)
          ],
          "storageKey": null
        },
        (v28/*: any*/)
      ],
      "storageKey": null
    },
    (v28/*: any*/)
  ],
  "storageKey": null
},
v74 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModule",
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        (v28/*: any*/),
        (v70/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "visualization",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v71/*: any*/)
              ],
              "type": "EventVisualization",
              "abstractKey": null
            },
            (v28/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v2/*: any*/),
    (v73/*: any*/)
  ],
  "type": "PageSectionSidebarEventsList",
  "abstractKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayQuestionsLabel",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayParticipationData",
  "storageKey": null
},
v77 = [
  (v3/*: any*/),
  (v28/*: any*/)
],
v78 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "results",
  "plural": true,
  "selections": (v77/*: any*/),
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "participativeModuleIds",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "ParticipativeModule",
  "kind": "LinkedField",
  "name": "participativeModules",
  "plural": true,
  "selections": [
    (v28/*: any*/),
    (v70/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "visualization",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v4/*: any*/),
        (v28/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Step",
      "kind": "LinkedField",
      "name": "currentStep",
      "plural": false,
      "selections": [
        (v47/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "position",
          "storageKey": null
        },
        (v28/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModuleAuthorizations",
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "votesDisplayAuthorized",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "votesDownAuthorized",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contributionsCountDisplayAuthorized",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votesUpCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votesDownCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contributionsCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarResource",
  "kind": "LinkedField",
  "name": "resources",
  "plural": true,
  "selections": [
    (v28/*: any*/),
    (v5/*: any*/),
    (v71/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endsAt",
      "storageKey": null
    },
    (v2/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventMode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "Sidebar",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasSections",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v35/*: any*/),
      "concreteType": "PageSectionBaseConnection",
      "kind": "LinkedField",
      "name": "sections",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageSectionBaseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v28/*: any*/),
                (v36/*: any*/),
                (v43/*: any*/),
                (v37/*: any*/),
                (v45/*: any*/),
                (v46/*: any*/),
                (v48/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    (v4/*: any*/),
                    (v49/*: any*/),
                    (v50/*: any*/),
                    (v13/*: any*/),
                    (v51/*: any*/),
                    (v52/*: any*/),
                    (v53/*: any*/),
                    (v55/*: any*/),
                    (v56/*: any*/),
                    (v62/*: any*/)
                  ],
                  "type": "PageSectionEmbed",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v63/*: any*/),
                    (v64/*: any*/),
                    (v65/*: any*/),
                    (v44/*: any*/)
                  ],
                  "type": "PageSectionSidebarBanner",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v66/*: any*/),
                    (v44/*: any*/)
                  ],
                  "type": "PageSectionFilesList",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v67/*: any*/),
                    (v44/*: any*/)
                  ],
                  "type": "PageSectionPagesList",
                  "abstractKey": null
                },
                (v69/*: any*/),
                (v74/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    (v49/*: any*/),
                    (v4/*: any*/),
                    (v75/*: any*/),
                    (v76/*: any*/),
                    (v78/*: any*/),
                    (v79/*: any*/)
                  ],
                  "type": "PageSectionParticipativeModuleResults",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v80/*: any*/),
                    (v44/*: any*/)
                  ],
                  "type": "PageSectionParticipativeModulesList",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    (v49/*: any*/),
                    (v81/*: any*/)
                  ],
                  "type": "PageSectionCalendar",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v82/*: any*/)
          ],
          "storageKey": null
        },
        (v83/*: any*/)
      ],
      "storageKey": "sections(first:2147483647)"
    },
    {
      "alias": null,
      "args": (v35/*: any*/),
      "filters": null,
      "handle": "connection",
      "key": "Sidebar_sections",
      "kind": "LinkedHandle",
      "name": "sections"
    },
    (v28/*: any*/)
  ],
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomDefault",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "markersMaxClusterRadius",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tileLayerUrl",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mapDataAttribution",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterElementsOutOnInitialize",
  "storageKey": null
},
v90 = [
  (v28/*: any*/)
],
v91 = [
  (v2/*: any*/),
  (v4/*: any*/),
  (v49/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MapInformationWindowQuery",
    "selections": [
      {
        "alias": "informationWindow",
        "args": (v1/*: any*/),
        "concreteType": "MapInformationWindow",
        "kind": "LinkedField",
        "name": "mapInformationWindow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "element",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MapElementPointStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "MapElementPoint",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MapElementCompoundFeatureStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapElementPathStyle",
                        "kind": "LinkedField",
                        "name": "borderStyle",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v12/*: any*/),
                          (v21/*: any*/),
                          (v7/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MapElementZoomLevelStyle",
                            "kind": "LinkedField",
                            "name": "zoomLevels",
                            "plural": true,
                            "selections": [
                              (v22/*: any*/),
                              (v23/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapElementBackgroundStyle",
                        "kind": "LinkedField",
                        "name": "backgroundStyle",
                        "plural": false,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapElementShadowStyle",
                        "kind": "LinkedField",
                        "name": "shadowStyle",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v5/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapElementZoomLevelStyle",
                        "kind": "LinkedField",
                        "name": "zoomLevels",
                        "plural": true,
                        "selections": [
                          (v22/*: any*/),
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "style",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": (v19/*: any*/),
                                "type": "MapElementCompoundFeatureStyle",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "MapElementCompoundFeature",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PageSections_page"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MapInformationWindowQuery",
    "selections": [
      {
        "alias": "informationWindow",
        "args": (v1/*: any*/),
        "concreteType": "MapInformationWindow",
        "kind": "LinkedField",
        "name": "mapInformationWindow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "element",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MapElementPointStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "MapElementPoint",
                "abstractKey": null
              },
              (v34/*: any*/),
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          (v28/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v35/*: any*/),
                "concreteType": "PageSectionBaseConnection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageSectionBaseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v28/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v38/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v84/*: any*/)
                            ],
                            "type": "PageSectionText",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v63/*: any*/),
                              (v64/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v84/*: any*/),
                              (v65/*: any*/)
                            ],
                            "type": "PageSectionBanner",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v49/*: any*/),
                              (v4/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v84/*: any*/),
                              (v80/*: any*/)
                            ],
                            "type": "PageSectionParticipativeModulesList",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v49/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayMode",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hideIfEmpty",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "events",
                                "plural": true,
                                "selections": [
                                  (v28/*: any*/),
                                  (v70/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "visualization",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v71/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "placeName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "address",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "zip",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "city",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "EventVisualization",
                                        "abstractKey": null
                                      },
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PageSectionEventsList",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v49/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v84/*: any*/),
                              (v81/*: any*/)
                            ],
                            "type": "PageSectionCalendar",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v49/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actorsPerRow",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contentAlignment",
                                "storageKey": null
                              },
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v84/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Actor",
                                "kind": "LinkedField",
                                "name": "actors",
                                "plural": true,
                                "selections": [
                                  (v28/*: any*/),
                                  (v47/*: any*/),
                                  (v49/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ResponsiveImage",
                                    "kind": "LinkedField",
                                    "name": "logo",
                                    "plural": false,
                                    "selections": (v61/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PageSectionActorsList",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v49/*: any*/),
                              (v67/*: any*/)
                            ],
                            "type": "PageSectionPagesList",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v49/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v84/*: any*/),
                              (v66/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isPageSectionWithHeadingData"
                              }
                            ],
                            "type": "PageSectionFilesList",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v49/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "blocksDisplayMode",
                                "storageKey": null
                              },
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FeaturedContentBlock",
                                "kind": "LinkedField",
                                "name": "featuredContentBlocks",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v28/*: any*/),
                                  (v2/*: any*/),
                                  (v49/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "image",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v57/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ResponsiveImage",
                                    "kind": "LinkedField",
                                    "name": "originalImage",
                                    "plural": false,
                                    "selections": [
                                      (v57/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "large",
                                        "plural": false,
                                        "selections": (v14/*: any*/),
                                        "storageKey": null
                                      },
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v84/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "blocksPerRow",
                                "storageKey": null
                              },
                              (v63/*: any*/),
                              (v64/*: any*/)
                            ],
                            "type": "PageSectionFeaturedContent",
                            "abstractKey": null
                          },
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v48/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v49/*: any*/),
                              (v51/*: any*/),
                              (v50/*: any*/),
                              (v13/*: any*/),
                              (v52/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isEmpty",
                                "storageKey": null
                              },
                              (v53/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v62/*: any*/)
                            ],
                            "type": "PageSectionEmbed",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v49/*: any*/),
                              (v75/*: any*/),
                              (v76/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v84/*: any*/),
                              (v78/*: any*/),
                              (v79/*: any*/)
                            ],
                            "type": "PageSectionParticipativeModuleResults",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v49/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mapHeight",
                                "storageKey": null
                              },
                              (v85/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "map",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ParticipativeModule",
                                        "kind": "LinkedField",
                                        "name": "participativeModule",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ParticipativeModuleAuthorizations",
                                            "kind": "LinkedField",
                                            "name": "authorizations",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "contributionsDisplayAuthorized",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v70/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "visualization",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v86/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ParticipativeModule",
                                                    "kind": "LinkedField",
                                                    "name": "participativeModule",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Theme",
                                                        "kind": "LinkedField",
                                                        "name": "themes",
                                                        "plural": true,
                                                        "selections": [
                                                          (v28/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "MapElementThemeStyle",
                                                            "kind": "LinkedField",
                                                            "name": "style",
                                                            "plural": false,
                                                            "selections": (v29/*: any*/),
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v28/*: any*/),
                                                      (v70/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "contributionsZIndexOffset",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "ContributionsMap",
                                                "abstractKey": null
                                              },
                                              (v28/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v28/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "VisualizationMap",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isMap"
                                  },
                                  (v70/*: any*/),
                                  (v28/*: any*/),
                                  (v85/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "zoomMin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "zoomMax",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mobileZoomDefault",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mobileZoomMin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mobileZoomMax",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "centerLatitude",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "centerLongitude",
                                    "storageKey": null
                                  },
                                  (v87/*: any*/),
                                  (v88/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapZoomLevelConfiguration",
                                    "kind": "LinkedField",
                                    "name": "zoomLevels",
                                    "plural": true,
                                    "selections": [
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v87/*: any*/),
                                      (v88/*: any*/),
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasElements",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "vectorTileUrl",
                                    "storageKey": null
                                  },
                                  (v86/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapElementPoint",
                                    "kind": "LinkedField",
                                    "name": "clusterizedPoints",
                                    "plural": true,
                                    "selections": [
                                      (v28/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasInformationWindow",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "latitude",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "longitude",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mapElementGeometryId",
                                        "storageKey": null
                                      },
                                      (v73/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MapElementTooltip",
                                        "kind": "LinkedField",
                                        "name": "tooltip",
                                        "plural": false,
                                        "selections": [
                                          (v38/*: any*/),
                                          (v28/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapFilterList",
                                    "kind": "LinkedField",
                                    "name": "filterLists",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "filters",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v28/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v89/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MapTaxonomy",
                                                "kind": "LinkedField",
                                                "name": "mapTaxonomies",
                                                "plural": true,
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "MapTaxonomy",
                                                    "kind": "LinkedField",
                                                    "name": "children",
                                                    "plural": true,
                                                    "selections": (v90/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "MapFilterTaxonomy",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v89/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "mapElements",
                                                "plural": true,
                                                "selections": (v77/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "MapFilterElement",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v35/*: any*/),
                                    "concreteType": "MapElementConnection",
                                    "kind": "LinkedField",
                                    "name": "elements",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MapElementEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v28/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MapTaxonomy",
                                                "kind": "LinkedField",
                                                "name": "mapTaxonomies",
                                                "plural": true,
                                                "selections": (v90/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isMapElement"
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "geometriesType",
                                                "storageKey": null
                                              },
                                              (v34/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "MapElementPathStyle",
                                                    "kind": "LinkedField",
                                                    "name": "style",
                                                    "plural": false,
                                                    "selections": (v31/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "MapElementPath",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v73/*: any*/)
                                                ],
                                                "type": "MapElementPoint",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "MapElementShapeStyle",
                                                    "kind": "LinkedField",
                                                    "name": "style",
                                                    "plural": false,
                                                    "selections": [
                                                      (v20/*: any*/),
                                                      (v32/*: any*/),
                                                      (v33/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "MapElementZoomLevelStyle",
                                                        "kind": "LinkedField",
                                                        "name": "zoomLevels",
                                                        "plural": true,
                                                        "selections": [
                                                          (v22/*: any*/),
                                                          (v23/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "style",
                                                            "plural": false,
                                                            "selections": [
                                                              (v3/*: any*/),
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v32/*: any*/),
                                                                  (v33/*: any*/)
                                                                ],
                                                                "type": "MapElementShapeStyle",
                                                                "abstractKey": null
                                                              },
                                                              (v28/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v28/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v28/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "MapElementShape",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v82/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v83/*: any*/)
                                    ],
                                    "storageKey": "elements(first:2147483647)"
                                  },
                                  {
                                    "alias": null,
                                    "args": (v35/*: any*/),
                                    "filters": null,
                                    "handle": "connection",
                                    "key": "MapElements_elements",
                                    "kind": "LinkedHandle",
                                    "name": "elements"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PageSectionMap",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v49/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SearchConfiguration",
                                "kind": "LinkedField",
                                "name": "searchConfiguration",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayOptionsByDefault",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PageSectionSearchBox",
                            "abstractKey": null
                          },
                          (v69/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              (v63/*: any*/),
                              (v64/*: any*/),
                              (v65/*: any*/),
                              (v44/*: any*/)
                            ],
                            "type": "PageSectionSidebarBanner",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v68/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayLabel",
                                "storageKey": null
                              },
                              (v38/*: any*/)
                            ],
                            "type": "PageSectionMapElementFeatureAttribute",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v49/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "defaultAcceptsCookiesValue",
                                "storageKey": null
                              }
                            ],
                            "type": "PageSectionCookiesConsentsConfiguration",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v91/*: any*/),
                            "type": "PageSectionSitemap",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v91/*: any*/),
                            "type": "PageSectionInformationSearch",
                            "abstractKey": null
                          },
                          (v74/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v82/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v83/*: any*/)
                ],
                "storageKey": "sections(first:2147483647)"
              },
              {
                "alias": null,
                "args": (v35/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Page_sections",
                "kind": "LinkedHandle",
                "name": "sections"
              }
            ],
            "type": "ResourceWithSections",
            "abstractKey": "__isResourceWithSections"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4d64a4d06be6302a544c2b16534e6fc8",
    "id": null,
    "metadata": {},
    "name": "MapInformationWindowQuery",
    "operationKind": "query",
    "text": "query MapInformationWindowQuery(\n  $informationWindowGeometryId: ID!\n) {\n  informationWindow: mapInformationWindow(informationWindowGeometryId: $informationWindowGeometryId) {\n    title\n    element {\n      __typename\n      ... on MapElementPoint {\n        style {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          id\n        }\n      }\n      ... on MapElementCompoundFeature {\n        style {\n          zIndexOffset\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          borderStyle {\n            color\n            opacity\n            style\n            width\n            zIndexOffset\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPathStyle {\n                  color\n                  opacity\n                  style\n                  width\n                  zIndexOffset\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          shadowStyle {\n            offsetX\n            offsetY\n            blur\n            color\n            opacity\n            id\n          }\n          zoomLevels {\n            zoomLevelMin\n            zoomLevelMax\n            style {\n              __typename\n              ... on MapElementCompoundFeatureStyle {\n                iconStyle {\n                  ... on MapElementImageStyle {\n                    __isMapElementImageStyle: __typename\n                    iconClass\n                    color\n                    contrastColor\n                    width\n                    height\n                    anchor\n                    anchorOffsetX\n                    anchorOffsetY\n                    opacity\n                    image {\n                      __typename\n                      ... on Image {\n                        url\n                      }\n                      ... on StaticImage {\n                        url\n                      }\n                    }\n                  }\n                  id\n                }\n              }\n              id\n            }\n            id\n          }\n          id\n        }\n      }\n      id\n    }\n    ...PageSections_page\n    id\n  }\n}\n\nfragment AnalyticsDatumCardRow_analyticsDatum on AnalyticsDatumInterface {\n  __isAnalyticsDatumInterface: __typename\n  label\n  count\n}\n\nfragment AudioPlayer_audio on Attachment {\n  url\n}\n\nfragment CalendarDayEventsPanel_events on CalendarResource {\n  id\n  ...CalendarResourceItem_event\n}\n\nfragment CalendarResourceItem_event on CalendarResource {\n  title\n  url\n  color\n  startsAt\n  endsAt\n  eventMode\n}\n\nfragment Calendar_section on PageSectionCalendar {\n  resources {\n    id\n    color\n    startsAt\n    endsAt\n    ...CalendarDayEventsPanel_events\n  }\n}\n\nfragment CardStep_step on Step {\n  name\n  startDate\n  endDate\n  isCurrent\n  position\n}\n\nfragment ContainerWithSidebar_sidebar on Sidebar {\n  hasSections\n  ...Sidebar_sidebar\n}\n\nfragment ContributionsMapContributionMarker_map on ContributionsMap {\n  contributionsZIndexOffset\n  participativeModule {\n    slug\n    themes {\n      id\n      style {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ContributionsMapContributionsMarkersManager_participativeModule on ParticipativeModule {\n  slug\n  visualization {\n    __typename\n    ... on ContributionsMap {\n      ...ContributionsMapContributionsMarkers_map\n    }\n    id\n  }\n}\n\nfragment ContributionsMapContributionsMarkers_map on ContributionsMap {\n  ...ContributionsMapThemeContributionsMarkers_map\n}\n\nfragment ContributionsMapThemeContributionsMarkers_map on ContributionsMap {\n  markersMaxClusterRadius\n  participativeModule {\n    themes {\n      id\n      style {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n  ...ContributionsMapContributionMarker_map\n}\n\nfragment EventCard_participativeModule on Event {\n  slug\n  title\n  visualization {\n    __typename\n    ... on EventVisualization {\n      startsAt\n      placeName\n      address\n      zip\n      city\n    }\n    id\n  }\n}\n\nfragment FeaturedContentBlockImage_block on FeaturedContentBlock {\n  url\n  originalImage {\n    altText\n    large {\n      url\n    }\n    id\n  }\n}\n\nfragment FeaturedContentBlockText_block on FeaturedContentBlock {\n  title\n  description\n  url\n  image {\n    url\n    altText\n  }\n}\n\nfragment FeaturedContentBlock_block on FeaturedContentBlock {\n  title\n  ...FeaturedContentBlockText_block\n  ...FeaturedContentBlockImage_block\n}\n\nfragment FeaturedContentCarousel_featuredContent on PageSectionFeaturedContent {\n  blocksPerRow\n  autoplay\n  slidesInterval\n  featuredContentBlocks {\n    id\n    ...FeaturedContentBlock_block\n  }\n}\n\nfragment FeaturedContentGrid_featuredContent on PageSectionFeaturedContent {\n  blocksPerRow\n  featuredContentBlocks {\n    id\n    ...FeaturedContentBlock_block\n  }\n}\n\nfragment LibraryFile_file on LibraryFile {\n  name\n  url\n  size\n  fileExtension\n}\n\nfragment LinkSlide_slide on Slide {\n  url\n}\n\nfragment MapBase_map on Map {\n  __isMap: __typename\n  id\n  zoomDefault\n  zoomMin\n  zoomMax\n  mobileZoomDefault\n  mobileZoomMin\n  mobileZoomMax\n  centerLatitude\n  centerLongitude\n  tileLayerUrl\n  mapDataAttribution\n  zoomLevels {\n    zoomLevelMin\n    zoomLevelMax\n    tileLayerUrl\n    mapDataAttribution\n    id\n  }\n  ...MapElementsVectorGrid_map\n}\n\nfragment MapClusterizedPointMarker_point on MapElementPoint {\n  id\n  hasInformationWindow\n  latitude\n  longitude\n  mapElementGeometryId\n  style {\n    zIndexOffset\n    iconStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    backgroundStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    zoomLevels {\n      zoomLevelMin\n      zoomLevelMax\n      style {\n        __typename\n        ... on MapElementPointStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        ... on MapElementCompoundFeatureStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  tooltip {\n    ...MapElementTooltip_tooltip\n    id\n  }\n}\n\nfragment MapClusterizedPointMarkers_map on Map {\n  __isMap: __typename\n  markersMaxClusterRadius\n  clusterizedPoints {\n    id\n    ...MapClusterizedPointMarker_point\n  }\n  ...useMapElementsFilteredIn_map\n}\n\nfragment MapContextProvider_map on Map {\n  __isMap: __typename\n  __typename\n  slug\n}\n\nfragment MapElementTooltip_tooltip on MapElementTooltip {\n  content\n}\n\nfragment MapElementsVectorGridTileLayerStyles_map on Map {\n  __isMap: __typename\n  elements(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        __isMapElement: __typename\n        id\n        geometriesType\n        ... on MapElementCompoundFeature {\n          style {\n            zIndexOffset\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            borderStyle {\n              color\n              opacity\n              style\n              width\n              zIndexOffset\n              zoomLevels {\n                zoomLevelMin\n                zoomLevelMax\n                style {\n                  __typename\n                  ... on MapElementPathStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            shadowStyle {\n              offsetX\n              offsetY\n              blur\n              color\n              opacity\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementCompoundFeatureStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementPath {\n          style {\n            color\n            opacity\n            style\n            width\n            zIndexOffset\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPathStyle {\n                  color\n                  opacity\n                  style\n                  width\n                  zIndexOffset\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementPoint {\n          style {\n            zIndexOffset\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPointStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                ... on MapElementCompoundFeatureStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementShape {\n          style {\n            zIndexOffset\n            borderStyle {\n              color\n              opacity\n              style\n              width\n              zIndexOffset\n              zoomLevels {\n                zoomLevelMin\n                zoomLevelMax\n                style {\n                  __typename\n                  ... on MapElementPathStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementShapeStyle {\n                  borderStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                    zoomLevels {\n                      zoomLevelMin\n                      zoomLevelMax\n                      style {\n                        __typename\n                        ... on MapElementPathStyle {\n                          color\n                          opacity\n                          style\n                          width\n                          zIndexOffset\n                        }\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...useMapElementsFilteredIn_map\n}\n\nfragment MapElementsVectorGrid_map on Map {\n  __isMap: __typename\n  id\n  hasElements\n  vectorTileUrl\n  ...MapClusterizedPointMarkers_map\n  ...MapElementsVectorGridTileLayerStyles_map\n}\n\nfragment MapSidebarEventsList_eventsList on PageSectionSidebarEventsList {\n  id\n  title\n  style {\n    zIndexOffset\n    iconStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    backgroundStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    zoomLevels {\n      zoomLevelMin\n      zoomLevelMax\n      style {\n        __typename\n        ... on MapElementPointStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        ... on MapElementCompoundFeatureStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  events {\n    id\n    ...SidebarEventCard_participativeModule\n  }\n}\n\nfragment PageSectionActorsList_pageSection on PageSectionActorsList {\n  title\n  iconClass\n  description\n  actorsPerRow\n  contentAlignment\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  actors {\n    id\n    name\n    description\n    logo {\n      ...ResponsiveImage_image\n      id\n    }\n  }\n}\n\nfragment PageSectionAnalyticsDataList_pageSection on PageSectionAnalyticsDataList {\n  title\n  description\n  analyticsData {\n    __typename\n    id\n    ...AnalyticsDatumCardRow_analyticsDatum\n  }\n}\n\nfragment PageSectionBanner_pageSection on PageSectionBanner {\n  autoplay\n  slidesInterval\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  slides {\n    id\n    ...Slide_slide\n  }\n}\n\nfragment PageSectionCalendar_pageSection on PageSectionCalendar {\n  title\n  iconClass\n  description\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  ...Calendar_section\n}\n\nfragment PageSectionCookiesConsentsConfiguration_pageSection on PageSectionCookiesConsentsConfiguration {\n  title\n  iconClass\n  description\n  defaultAcceptsCookiesValue\n}\n\nfragment PageSectionEmbed_pageSection on PageSectionEmbed {\n  title\n  iconClass\n  description\n  hlsUrl\n  code\n  url\n  format\n  isEmpty\n  mediaTitle\n  collapsible\n  collapsedHeight\n  transcription {\n    url\n    id\n  }\n  audio {\n    url\n    ...AudioPlayer_audio\n    id\n  }\n  ...VideoPlayer_withVideoStream\n}\n\nfragment PageSectionEventsList_pageSection on PageSectionEventsList {\n  title\n  description\n  displayMode\n  hideIfEmpty\n  events {\n    id\n    ...EventCard_participativeModule\n  }\n}\n\nfragment PageSectionFeaturedContent_pageSection on PageSectionFeaturedContent {\n  title\n  iconClass\n  description\n  blocksDisplayMode\n  columnsRatio\n  columnsOrder\n  collapsible\n  collapsedHeight\n  featuredContentBlocks {\n    __typename\n    id\n  }\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  ...FeaturedContentGrid_featuredContent\n  ...FeaturedContentCarousel_featuredContent\n}\n\nfragment PageSectionFilesList_pageSection on PageSectionFilesList {\n  title\n  iconClass\n  description\n  columnsRatio\n  columnsOrder\n  sidebar {\n    hasSections\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  files {\n    id\n    ...LibraryFile_file\n  }\n}\n\nfragment PageSectionInformationSearch_pageSection on PageSectionInformationSearch {\n  id\n  title\n  iconClass\n  description\n}\n\nfragment PageSectionMapElementFeatureAttribute_pageSection on PageSectionMapElementFeatureAttribute {\n  label\n  displayLabel\n  content\n}\n\nfragment PageSectionMap_pageSection on PageSectionMap {\n  title\n  description\n  mapHeight\n  zoomDefault\n  map {\n    __typename\n    ... on VisualizationMap {\n      participativeModule {\n        authorizations {\n          contributionsDisplayAuthorized\n        }\n        ...ContributionsMapContributionsMarkersManager_participativeModule\n        id\n      }\n    }\n    ...MapContextProvider_map\n    ...MapBase_map\n    id\n  }\n}\n\nfragment PageSectionPagesList_pageSection on PageSectionPagesList {\n  title\n  iconClass\n  description\n  resourceTargets {\n    id\n    name\n    url\n  }\n}\n\nfragment PageSectionParticipativeModuleResults_pageSection on PageSectionParticipativeModuleResults {\n  title\n  iconClass\n  description\n  displayQuestionsLabel\n  displayParticipationData\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  results {\n    __typename\n    id\n  }\n  ...ParticipativeModuleResultsFormFields_pageSection\n}\n\nfragment PageSectionParticipativeModulesList_pageSection on PageSectionParticipativeModulesList {\n  title\n  description\n  iconClass\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  participativeModules {\n    id\n    ...ParticipativeModuleCard_participativeModule\n  }\n}\n\nfragment PageSectionSearchBox_pageSection on PageSectionSearchBox {\n  title\n  iconClass\n  description\n  searchConfiguration {\n    id\n    displayOptionsByDefault\n  }\n}\n\nfragment PageSectionSidebarAnalyticsDataList_pageSection on PageSectionAnalyticsDataList {\n  title\n  description\n  analyticsData {\n    __typename\n    id\n    ...AnalyticsDatumCardRow_analyticsDatum\n  }\n}\n\nfragment PageSectionSidebarBanner_pageSection on PageSectionSidebarBanner {\n  fullHeight\n  autoplay\n  slidesInterval\n  slides {\n    id\n    ...Slide_slide\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarCalendar_pageSection on PageSectionCalendar {\n  title\n  description\n  ...Calendar_section\n}\n\nfragment PageSectionSidebarEmbed_pageSection on PageSectionEmbed {\n  title\n  iconClass\n  description\n  code\n  url\n  hlsUrl\n  format\n  mediaTitle\n  transcription {\n    url\n    id\n  }\n  audio {\n    url\n    ...AudioPlayer_audio\n    id\n  }\n  ...VideoPlayer_withVideoStream\n}\n\nfragment PageSectionSidebarEventsList_pageSection on PageSectionSidebarEventsList {\n  id\n  events {\n    id\n    ...SidebarEventCard_participativeModule\n  }\n  ...MapSidebarEventsList_eventsList\n}\n\nfragment PageSectionSidebarFilesList_pageSection on PageSectionFilesList {\n  files {\n    id\n    ...LibraryFile_file\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarLinkBlock_pageSection on PageSectionSidebarLinkBlock {\n  title\n  subtitle\n  iconClass\n  url\n}\n\nfragment PageSectionSidebarPagesList_pageSection on PageSectionPagesList {\n  resourceTargets {\n    id\n    name\n    url\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarParticipativeModuleResults_pageSection on PageSectionParticipativeModuleResults {\n  title\n  description\n  iconClass\n  displayQuestionsLabel\n  displayParticipationData\n  results {\n    __typename\n    id\n  }\n  ...ParticipativeModuleResultsFormFields_pageSection\n}\n\nfragment PageSectionSidebarParticipativeModulesList_pageSection on PageSectionParticipativeModulesList {\n  participativeModules {\n    id\n    ...ParticipativeModuleCard_participativeModule\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarText_pageSection on PageSectionSidebarText {\n  content\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarUsersGroupRequestLinkBlock_pageSection on PageSectionSidebarUsersGroupRequestLinkBlock {\n  iconClass\n  addRequestTitle\n  removeRequestTitle\n  usersGroup {\n    id\n    name\n    alreadyGroupMember\n    alreadyRequested\n    authorizations {\n      sendJoinGroupRequest\n    }\n  }\n}\n\nfragment PageSectionSidebar_pageSection on PageSectionBase {\n  __isPageSectionBase: __typename\n  __typename\n  ...PageSectionSidebarText_pageSection\n  ...PageSectionSidebarLinkBlock_pageSection\n  ...PageSectionSidebarUsersGroupRequestLinkBlock_pageSection\n  ...PageSectionSidebarEmbed_pageSection\n  ...PageSectionSidebarBanner_pageSection\n  ...PageSectionSidebarFilesList_pageSection\n  ...PageSectionSidebarPagesList_pageSection\n  ...PageSectionSidebarAnalyticsDataList_pageSection\n  ...PageSectionSidebarEventsList_pageSection\n  ...PageSectionSidebarParticipativeModuleResults_pageSection\n  ...PageSectionSidebarParticipativeModulesList_pageSection\n  ...PageSectionSidebarCalendar_pageSection\n}\n\nfragment PageSectionSitemap_pageSection on PageSectionSitemap {\n  title\n  iconClass\n  description\n}\n\nfragment PageSectionText_pageSection on PageSectionText {\n  content\n  collapsible\n  collapsedHeight\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n}\n\nfragment PageSection_pageSection on PageSectionBase {\n  __isPageSectionBase: __typename\n  __typename\n  ...PageSectionText_pageSection\n  ...PageSectionBanner_pageSection\n  ...PageSectionParticipativeModulesList_pageSection\n  ...PageSectionEventsList_pageSection\n  ...PageSectionCalendar_pageSection\n  ...PageSectionActorsList_pageSection\n  ...PageSectionPagesList_pageSection\n  ...PageSectionFilesList_pageSection\n  ...PageSectionFeaturedContent_pageSection\n  ...PageSectionSidebarText_pageSection\n  ...PageSectionSidebarLinkBlock_pageSection\n  ...PageSectionSidebarUsersGroupRequestLinkBlock_pageSection\n  ...PageSectionEmbed_pageSection\n  ...PageSectionParticipativeModuleResults_pageSection\n  ...PageSectionMap_pageSection\n  ...PageSectionSearchBox_pageSection\n  ...PageSectionAnalyticsDataList_pageSection\n  ...PageSectionSidebarFilesList_pageSection\n  ...PageSectionSidebarBanner_pageSection\n  ...PageSectionMapElementFeatureAttribute_pageSection\n  ...PageSectionCookiesConsentsConfiguration_pageSection\n  ...PageSectionSitemap_pageSection\n  ...PageSectionInformationSearch_pageSection\n  ...PageSectionSidebarEventsList_pageSection\n}\n\nfragment PageSections_page on ResourceWithSections {\n  __isResourceWithSections: __typename\n  sections(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        domId\n        ...PageSection_pageSection\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ParticipativeModuleCard_participativeModule on ParticipativeModule {\n  slug\n  title\n  thumbUrl\n  visualization {\n    __typename\n    iconClass\n    id\n  }\n  currentStep {\n    ...CardStep_step\n    id\n  }\n  ...ParticipativeModuleMeasures_participativeModule\n}\n\nfragment ParticipativeModuleMeasures_participativeModule on ParticipativeModule {\n  authorizations {\n    votesDisplayAuthorized\n    votesDownAuthorized\n    contributionsCountDisplayAuthorized\n  }\n  votesUpCount\n  votesDownCount\n  contributionsCount\n}\n\nfragment ParticipativeModuleResultsFormFields_pageSection on PageSectionParticipativeModuleResults {\n  id\n  participativeModuleIds\n}\n\nfragment ResponsiveImage_image on ResponsiveImage {\n  altText\n  large {\n    ratio\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n  medium {\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n  small {\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n}\n\nfragment SidebarEventCard_participativeModule on ParticipativeModule {\n  slug\n  title\n  visualization {\n    __typename\n    ... on EventVisualization {\n      startsAt\n    }\n    id\n  }\n}\n\nfragment Sidebar_sidebar on Sidebar {\n  sections(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        domId\n        fullHeight\n        ...PageSectionSidebar_pageSection\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SlideCaption_slide on Slide {\n  caption\n}\n\nfragment SlideContainer_slide on Slide {\n  url\n  enableOverlay\n  ...LinkSlide_slide\n}\n\nfragment SlideOverlay_slide on Slide {\n  url\n  enableOverlay\n  overlayContent\n  overlayButtonText\n  overlayContentPosition\n  overlayContentTextColor\n  overlayButtonBackgroundColor\n  overlayButtonTextColor\n  overlayBackgroundColor\n  overlayOpacity\n}\n\nfragment Slide_slide on Slide {\n  ...SlideContainer_slide\n  ...SlideCaption_slide\n  ...SlideOverlay_slide\n  image {\n    ...ResponsiveImage_image\n    id\n  }\n}\n\nfragment VideoPlayer_withVideoStream on WithBunnyStreamVideo {\n  __isWithBunnyStreamVideo: __typename\n  hlsUrl\n  hlsLibUrl\n  width\n  height\n  cover {\n    ...ResponsiveImage_image\n    id\n  }\n}\n\nfragment useMapElementsFilteredIn_map on Map {\n  __isMap: __typename\n  id\n  filterLists {\n    filters {\n      __typename\n      id\n      ... on MapFilterTaxonomy {\n        filterElementsOutOnInitialize\n        mapTaxonomies {\n          id\n          children {\n            id\n          }\n        }\n      }\n      ... on MapFilterElement {\n        filterElementsOutOnInitialize\n        mapElements {\n          __typename\n          id\n        }\n      }\n    }\n    id\n  }\n  elements(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        mapTaxonomies {\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useSidebarSectionTitle_pageSection on PageSectionWithHeadingData {\n  __isPageSectionWithHeadingData: __typename\n  title\n  iconClass\n}\n"
  }
};
})();

node.hash = "b075be05725282b44b4edbe0221b7d1c";

module.exports = node;
